module.exports = __webpack_public_path__ + "static/media/innovation_.90f6ac04.svg";